export default __webpack_public_path__ + "static/stuck-8bdf7a9d92866eebfd5b09f3e9064740.png";